import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable({
    providedIn: 'root'
})
export class MotorCarrierFleetService extends BaseApiService {

    constructor() {
        super();
    }

    /**
	 * Gets the motor carrier account fleets for the mca
	 * @param motorCarrierAccountNumberId The motor carrier account number id
	 */
    public getDashboardMotorCarrierAccountFleets(motorCarrierAccountNumberId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountNumberId}/Fleet/Dashboard`);
    }

    /**
	 * Gets the motor carrier account fleets for the mca
	 * @param motorCarrierAccountNumberId The motor carrier account number id
	 */
    public getMotorCarrierAccountFleets(motorCarrierAccountNumberId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountNumberId}/Fleet`);
    }

    /**
	 * Creates a motor carrier account fleet
	 * @param data The create motor carrier fleet model
	 */
    public createMotorCarrierAccountFleet(data: any): Observable<any>{
        return this.put('IRP/MotorCarrier/Fleet', data);
    }

    /**
	 * Saves a motor carrier account fleet
	 * @param data The create motor carrier fleet model
	 */
    public saveMotorCarrierAccountFleet(data: any): Observable<any> {
        return this.post('IRP/MotorCarrier/Fleet', data);
    }

    /**
	 * Gets the motor carrier account fleet
	 * @param motorCarrierAccountFleetId The motor carrier account fleet id
	 */
    public getMotorCarrierAccountFleet(motorCarrierAccountFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountFleetId}`);
    }

    /**
	 * Gets the motor carrier account fleet
	 * @param motorCarrierAccountFleetId The motor carrier account fleet id
	 */
    public getMotorCarrierAccountFleetVehicleOptional(motorCarrierAccountFleetId: number, includeVehicles: boolean): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountFleetId}/Vehicles/${includeVehicles}`);
    }

    /**
	 *  Gets the motor carrier account fleet vehicles
	 * @param motorCarrierAccountFleetId
	 */
    public getMotorCarrierAccountFleetVehicles(motorCarrierAccountFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountFleetId}/FleetVehicles`);
    }
    /**
	 *  Gets the count of motor carrier account fleet vehicles.
	 * @param motorCarrierAccountNumberId
	 */
    public getTotalNumberOfVehicles(motorCarrierAccountNumberId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountNumberId}/FleetVehicleCount`);
    }

    /**
	 * Gets the motor carrier account information with some fleet details for the given fleet
	 * @param motorCarrierAccountFleetId: Fleet to get the account details for
	 */
    public getMotorCarrierAccountByFleetId(motorCarrierAccountFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountFleetId}/Account`);
    }

    /**
	 *  Gets the count of motor carrier account fleet vehicles.
	 * @param motorCarrierAccountFleetId
	 */
    public getTotalNumberOfVehiclesForFleet(motorCarrierAccountFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierAccountFleetId}/FleetVehicleCount`);
    }

    /**
	 * Gets the motor carrier account fleets for the mca
	 * @param motorCarrierAccountNumberId The motor carrier account number id
	 */
    public getMotorCarrierAccountFleetHistory(motorCarrierAccountNumberId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountNumberId}/FleetHistory`);
    }

    /**
	 * check the prior fleet is active
	 * @param motorCarrierAccountNumberId
	 * @param motorCarrierAccountFleetId
	 */
    public checkPriorFleetIsActive(motorCarrierAccountNumberId: number, motorCarrierAccountFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountNumberId}/Fleet/${motorCarrierAccountFleetId}/CheckPriorFleet`);
    }
    /**
	 *  Gets the motor carrier account fleet vehicles
	 * @param motorCarrierAccountFleetId
	 */
    public getMotorCarrierAccountAllFleetVehicles(motorCarrierAccountFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/${motorCarrierAccountFleetId}/FleetVehicles/IncludeInActive`);
    }

    /**
	 *  Gets the motor carrier account fleet vehicles
	 * @param motorCarrierAccountFleetId
	 */
    public createRenewalNotice(motorCarrierFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierFleetId}/Renewal`);
    }

    /**
     * Gets the motor carrier fleet reporting period date
     * @param motorCarrierFleetId
     */
    public getReportingPeriodDate(motorCarrierFleetId: number): Observable<any> {
        return this.get(`IRP/MotorCarrier/Fleet/${motorCarrierFleetId}/ReportingPeriod`);
    }
}
